/**
 * A note displaying a message in a page.
 *
 * Author: Bounlith Sirivong <bounlith.sirivong@ircamamplify.com>
 * Copyright © Ircam Amplify 2026
 */
import './PageNote.css'

interface PageNoteProps {
  message: string
}

export const PageNote = (props: PageNoteProps) => (
  <div className="page-note">
    <div className="left-border" />
    <div>{props.message}</div>
  </div>
)
